import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { PreventivoResponseDTO, EmissioneResponseDTO, GetSignLinkResponseDTO, AskAIResponseDTO } from './preventivo';

import { Observable } from 'rxjs/internal/Observable';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BackendApi {
  private readonly baseUrl = environment.apiBaseUrl;
  private readonly functionKey = environment.functionKey;

  constructor(private http: HttpClient) { }

  warmUp(): Observable<string> {
    let params = new HttpParams();
    if (this.functionKey) {
      params = params.set('code', this.functionKey);
    }

    return this.http.get(`${this.baseUrl}/api/WarmUp`, {
      params,
      responseType: 'text'
    });
  }

  creaPreventivo(body: any): Observable<PreventivoResponseDTO> {
    let params = new HttpParams();
    if (this.functionKey) {
      params = params.set('code', this.functionKey);
    }

    return this.http.post<PreventivoResponseDTO>(`${this.baseUrl}/api/CreaPreventivo`, body, { params });
  }

  emettiPolizza(body: any): Observable<EmissioneResponseDTO> {
    let params = new HttpParams();
    if (this.functionKey) {
      params = params.set('code', this.functionKey);
    }

    return this.http.post<EmissioneResponseDTO>(`${this.baseUrl}/api/EmissionePolizza`, body, { params });
  }

  getSignLink(contractId: string): Observable<GetSignLinkResponseDTO> {
    let params = new HttpParams().set('contractId', contractId);
    if (this.functionKey) {
      params = params.set('code', this.functionKey);
    }

    return this.http.get<GetSignLinkResponseDTO>(`${this.baseUrl}/api/GetSignLink`, { params });
  }

  askAI(body: any): Observable<AskAIResponseDTO> {
    let params = new HttpParams();
    if (this.functionKey) {
      params = params.set('code', this.functionKey);
    }

    return this.http.post<AskAIResponseDTO>(`${this.baseUrl}/api/AskAI`, body, { params });
  }
}
